module.exports = __webpack_public_path__ + "img/loading.f4404720.gif";